import React from "react";

export default function PrivacyPolicy() {
  return (
    <section className="terms-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="primary-heading color-dark">
          <h3 className="mb-3">Privacy Policy</h3>
          <p className="text-justify">
            Welcome to Bnr360! This Privacy Policy outlines how we collect, use,
            disclose, and protect your personal information when you use our
            platform. By accessing or using Bnr360, you agree to the terms
            outlined in this Privacy Policy.
          </p>
          <h5>1. Information We Collect:</h5>
          <p className="text-justify">
            Account Information: When you register on Bnr360, we collect
            information such as your name, email address, and other relevant
            details to create and manage your account.
          </p>
          <p className="text-justify">
            Profile Information: Freelancers can choose to provide additional
            information on their profiles, including skills, work experience,
            and portfolio.
          </p>
          <p className="text-justify">
            Payment Information: For transactions, we collect necessary payment
            information through secure third-party payment processors.
          </p>
          <p className="text-justify">
            Usage Data: We may collect information about your interactions with
            the platform, including pages visited, actions taken, and other
            usage patterns.
          </p>
          <h5>2. How We Use Your Information:</h5>
          <p className="text-justify">
            To Provide Services: We use your information to facilitate the
            freelancing process, connecting freelancers with clients, managing
            projects, and processing payments.
          </p>
          <p className="text-justify">
            Communication: We may use your contact information to send important
            updates, newsletters, and other relevant communications.
          </p>
          <p className="text-justify">
            Improving Services: We analyze user data to enhance our platform,
            optimize user experience, and develop new features.
          </p>
          <h5>3. Your Choices:</h5>
          <p className="text-justify">
            You can manage your account preferences and communication settings.
            You have the right to access, correct, or delete your personal
            information.
          </p>
          <h5>4. Changes to Privacy Policy:</h5>
          <p className="text-justify">
            We may update this Privacy Policy periodically. Continued use of the
            platform constitutes acceptance of the updated policy.
          </p>
          <h5>5. Contact Us:</h5>
          <p className="text-justify">
            For any questions, concerns, or requests regarding your privacy.
          </p>
        </div>
      </div>
    </section>
  );
}
